<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",

  mounted() {
    if (localStorage.getItem("lang")) {
      this.$i18n.locale = localStorage.getItem("lang");
    } else {
      this.$i18n.locale = "fcn";
    }
  }
};
</script>

<style>
#app {
  min-width: 1920px;
  height: 100%;
  min-height: 900px;
  /*font-family: Roboto, Arial, Helvetica, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";*/
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media screen and (max-width: 700px) {
  #app {
    max-width: 500px;
  }
}
/* 设置滚动条的宽度和高度 */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* 设置滚动条的轨道样式 */
::-webkit-scrollbar-track {
  background-color: #ccc5;
  border-radius: 5px;
}

/* 设置滚动条滑块的样式 */
::-webkit-scrollbar-thumb {
  background-color: #4ab1e499;
  border-radius: 5px;
}

/* 鼠标悬停在滚动条上时的样式 */
::-webkit-scrollbar-thumb:hover {
  background-color: #4ab1e488;
}
</style>



// WEBPACK FOOTER //
// src/App.vue